/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useState, useEffect } from "react";
import { Stack } from "@mui/material";
import { ComponentTestimonialContext } from "./component-testimonial-context";
import { ListImage } from "./list-image";
import LabelledField from "components/labelled-field";
import { TextField } from "@mui/material";
import { SimplicityComposerEnsureTipTap } from "cms/rich-text/simplicity-composer-tiptap";

const TestimonialItemEditor = () => {
    const componentTestimonialContext = useContext(ComponentTestimonialContext);
    const index = componentTestimonialContext?.index;
    const position = componentTestimonialContext?.position;
    const item = componentTestimonialContext?.item;
    const updateItemByPosition = componentTestimonialContext?.updateItemByPosition;
    const _image = item?.image;
    const _name = item?.name;
    const _role = item?.role;
    const _company = item?.company;
    const _quote = item?.quote;

    const [image, setImage] = useState(_image); // guid
    const [name, setName] = useState(_name);
    const [role, setRole] = useState(_role);
    const [company, setCompany] = useState(_company);
    const [quote, setQuote] = useState(_quote);

    const updateImage = (guid) => {
        setImage(guid);
    };

    const updateName = (event) => {
        const name = event.target.value;
        setName(name);
    };
    const updateRole = (event) => {
        const role = event.target.value;
        setRole(role);
    };
    const updateCompany = (event) => {
        const company = event.target.value;
        setCompany(company);
    };
    const onChangeQuote = (quote) => {
        setQuote(quote);
    };

    useEffect(
        () => {
            const nextItem = structuredClone({
                ...item,
                image,
                name,
                role,
                company,
                quote,
            });
            updateItemByPosition(nextItem, position);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [image, name, role, company, quote]
    );

    return (
        <div className="simplicity-testimonial-item">
            <Stack direction="row" justifyContent="flex-start">
                <div className="simplicity-testimonial-item-data">
                    <div className="simplicity-testimonial-item-data-first-row">
                        <div className="list-image">
                            <ListImage
                                index={index}
                                image={image}
                                updateImage={updateImage}
                            />
                        </div>
                        <div className="list-info">
                            <div className="list-info-name">
                                <LabelledField label="Name">
                                    <TextField
                                        id="testimonial_name"
                                        fullWidth={true}
                                        value={name}
                                        placeholder="Add a name"
                                        onChange={updateName}
                                    />
                                </LabelledField>
                            </div>
                            <div className="list-info-role">
                                <LabelledField label="Role">
                                    <TextField
                                        id="testimonial_role"
                                        fullWidth={true}
                                        value={role}
                                        placeholder="Add a role"
                                        onChange={updateRole}
                                    />
                                </LabelledField>
                            </div>
                            <div className="list-info-company">
                                <LabelledField label="Company">
                                    <TextField
                                        id="testimonial_company"
                                        fullWidth={true}
                                        value={company}
                                        placeholder="Add a Company"
                                        onChange={updateCompany}
                                    />
                                </LabelledField>
                            </div>
                        </div>
                    </div>
                    <div className="simplicity-testimonial-item-data-second-row">
                        <LabelledField label="Quote">
                            <SimplicityComposerEnsureTipTap
                                richtext={quote}
                                onChange={onChangeQuote}
                                enableQuoteDefault
                            />
                        </LabelledField>
                    </div>
                </div>
            </Stack>
        </div>
    );
};
TestimonialItemEditor.displayName = "TestimonialItemEditor";
export { TestimonialItemEditor };
